import { Box, Typography } from '@mui/material';
import React from 'react';

interface Props {
  title?: string;
  height?: string;
  showImage?: boolean;
}

export const NoData: React.FC<Props> = ({ title = 'Nenhum dado encontrado', height = '80vh', showImage = true }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height }}>
      {showImage && <img src="../../../../content/images/no-data-sheet.png" />}
      <Typography sx={{ color: 'text.secondary', marginTop: showImage ? 2 : 0, fontSize: '1.2rem', fontWeight: '600', textAlign: 'center' }}>
        {title}
      </Typography>
    </Box>
  );
};
